import { Dispatch } from "react";

type payLoadType = {
  height: number[];
  si: number;
  ei: number;
};

export default class Sorting {
  private setHeight: Dispatch<{
    type: string;
    payload: payLoadType;
  }>;

  constructor(
    setHeight: Dispatch<{
      type: string;
      payload: payLoadType;
    }>
  ) {
    this.setHeight = setHeight;
  }

  private sleep = (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  // Bubble Sort
  public BubbleSort = async (arr: number[]): Promise<void> => {
    for (let i: number = 0; i < arr.length; i++) {
      for (let j: number = 1; j < arr.length - i; j++) {
        if (arr[j] < arr[j - 1]) {
          let temp = arr[j];
          arr[j] = arr[j - 1];
          arr[j - 1] = temp;
        }
        this.setHeight({
          type: "UPDATE",
          payload: { height: arr, si: j - 1, ei: j },
        });
        await this.sleep(500);
      }
    }
  };

  // Selection Sort
  public SelectionSort = async (arr: number[]): Promise<void> => {
    for (let i: number = 0; i < arr.length; i++) {
      let largeIndex = 0;
      let unsortedIndex = arr.length - i - 1;
      for (let j: number = 1; j < arr.length - i; j++) {
        if (arr[j] > arr[largeIndex]) {
          largeIndex = j;
        }
        this.setHeight({
          type: "UPDATE",
          payload: { height: arr, si: largeIndex, ei: j },
        });
        await this.sleep(500);
      }
      let temp = arr[unsortedIndex];
      arr[unsortedIndex] = arr[largeIndex];
      arr[largeIndex] = temp;
    }
  };

  // Insertion Sort
  public InsertionSort = async (arr: number[]): Promise<void> => {
    console.log(arr);
    for (let i: number = 1; i < arr.length; i++) {
      let sortedIndex: number = i - 1;
      let unsortedNumber: number = arr[i];
      while (sortedIndex >= 0 && unsortedNumber < arr[sortedIndex]) {
        arr[sortedIndex + 1] = arr[sortedIndex];
        sortedIndex--;
        this.setHeight({
          type: "UPDATE",
          payload: { height: arr, si: i, ei: sortedIndex },
        });
        await this.sleep(500);
      }
      arr[sortedIndex + 1] = unsortedNumber;
    }
    console.log(arr);
  };

  // Shell Sort
  public ShellSort = async (arr: number[]): Promise<void> => {
    console.log(arr);
    for (
      let gap: number = Math.floor(arr.length / 2);
      gap > 0;
      gap = Math.floor(gap / 2)
    ) {
      for (let i: number = Math.floor(gap); i < arr.length; i++) {
        let temp: number = arr[i];
        let j: number = i;
        for (j = i; j >= gap && temp < arr[j - gap]; j -= gap) {
          arr[j] = arr[j - gap];
          this.setHeight({
            type: "UPDATE",
            payload: { height: arr, si: i, ei: j - gap },
          });
          await this.sleep(500);
        }
        arr[j] = temp;
      }
    }
    console.log(arr);
  };

  // Heap Sort
  public HeapSort = async (arr: number[]): Promise<void> => {};

  // Merge sort
  public MergeSort = async (arr: number[]): Promise<void> => {
    let low: number = 0;
    let high: number = arr.length - 1;
    let temp: number[] = [...arr];
    for (let m: number = 1; m <= high - low; m = 2 * m) {
      for (let i: number = low; i < high; i += 2 * m) {
        let from: number = i;
        let mid: number = i + m - 1;
        let to: number = Math.min(i + 2 * m - 1, high);
        
        await this.merge(arr, temp, from, mid, to);
        this.setHeight({ type: "UPDATE", payload: { height: temp, si: from, ei: to  } });
        await this.sleep(500);
      }
    }
  }

  public merge = async (A: number[], temp: number[], from: number, mid: number, to: number): Promise<void> => {
    let k: number = from;
    let i: number = from;
    let j: number = mid + 1;
    while (i <= mid && j <= to) {
      if (A[i] < A[j]) {
        temp[k++] = A[i++];
      } else {
        temp[k++] = A[j++];
      }
      // this.setHeight({ type: "UPDATE", payload: { height: temp, si: i, ei: j  } });
      // await this.sleep(500);
    }
    while (i < A.length && i <= mid) {
      temp[k++] = A[i++];
      // this.setHeight({ type: "UPDATE", payload: { height: temp, si: i, ei: j  } });
      // await this.sleep(500);
    }
    for (i = from; i <= to; i++) {
      A[i] = temp[i];
    }
  }

  public partition = async (arr: number[], low: number, high: number): Promise<number> => {
    let pivot: number = arr[high];
    let i: number = (low - 1);
    for (let j: number = low; j < high; j++) {
      if (arr[j] < pivot) {
        i++;
        let temp: number = arr[i];
        arr[i] = arr[j];
        arr[j] = temp;
      }
      await this.sleep(500);
      this.setHeight({ type: "UPDATE", payload: { height: arr, si: i, ei: j  }  });
    }
    let temp: number = arr[i + 1];
    arr[i + 1] = arr[high];
    arr[high] = temp;
    this.setHeight({ type: "UPDATE", payload: { height: arr, si: i, ei: high }  });
    return i + 1;
  }

  public quickSort = async (arr: number[], low: number, high: number) => {
    if (low < high) {
      //* On doing the quicksort partationing the pivot lands at its rightfull position
      let pi: number = await this.partition(arr, low, high);
      await this.quickSort(arr, low, pi - 1);
      await this.quickSort(arr, pi + 1, high);
    }
    this.setHeight({ type: "UPDATE", payload: { height: arr, si: low, ei: high  }  });
  }
}
